const state = {
    hasPermission: true // false为未登录状态
};
const mutations = {
    setPermission: (state:any, value:number) => {
        state.hasPermission = value;
    }
};

export default {
    namespaced: true, // 这个是命名空间，用来区分不同的模块，我是根据文件的名字来区分
    state,
    mutations
};
